export default __webpack_public_path__ + "static/media/pictogramEFTPOS48.4510031c.svg";